import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import * as route from "../helpers/routes";
import PageHeader from "../gamePlayComponents/PageHeader";
import CardContainer from "../courseContentDisplays/CardContainer";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import {Flex} from "reflexbox";
import Button from "@mui/material/Button";
import { writeTeamName } from '../../helpers/dbFunctions';

const { TEAMNAME: TEAMNAME_ROUTE, END } = route;


const TeamNameInGamePrompt = (props) => {
  const user = useSelector((state) => state.user);
  const { uid } = user;
  const currentTeamId = useSelector((state) => state.team?.currentTeamId);
  const teamNameFromRedux = useSelector((state) => state.team?.teamDetails?.teamName) ?? '';
  const [teamName, setTeamName] = useState(teamNameFromRedux || '');
  const navigate = useNavigate();
  const viewingIndividualPage = window.location.pathname === TEAMNAME_ROUTE;
  const isBeforeEnd = props.nextURL?.endsWith(END);

  useEffect(() => {
    setTeamName((prev) => teamNameFromRedux || prev || '');
  }, [teamNameFromRedux]);

  //logic to skip this page if the user already set the team name
  useEffect(() => {
    if (!viewingIndividualPage && props.nextURL && teamNameFromRedux?.trim()) {
      navigate(props.nextURL);
    }
  }, [viewingIndividualPage, props.nextURL, teamNameFromRedux, navigate]);

  const handleSubmit = () => {
    if (currentTeamId) {
      writeTeamName(currentTeamId, teamName);
    }
    if (viewingIndividualPage) {
      navigate(-1);
    } else {
      navigate(props.nextURL);
    }
  };

  const cardContent1 = (<>
    <Typography variant="h6" style={{fontWeight: 'bold', paddingBottom: '16px'}}>
      {isBeforeEnd ? 'Before we call this done' : 'Quick intermission'}
    </Typography>
    <Typography style={{fontWeight: 'bold', paddingBottom: '8px'}}> We need a team name for the leaderboard. </Typography>
    {(!viewingIndividualPage && !teamNameFromRedux && !isBeforeEnd) && <Typography variant={'caption'} style={{paddingTop: '16px'}}> You can change this later from the menu in the top left. </Typography>}
    <Flex style={{marginTop: '24px'}}>
      <TextField
        label="Your team name"
        variant="filled"
        value={teamName || ""}
        onChange={(e) => setTeamName(e.target.value)}
        style={{width: '100%'}}
      />
    </Flex>

  </>);

  const actionButton = (<Flex style={{justifyContent: 'center', padding: '8px'}}>
    <Button variant={'contained'} color={'primary'} style={{minWidth: '107px'}}
            onClick={ handleSubmit} 
            >  {viewingIndividualPage ? 'Save' : (teamName?.trim() ? 'Continue' : 'Skip') } </Button>
    </Flex>);

  return (
    <>
      {viewingIndividualPage && <PageHeader title={'Team Name'} goBack/>}
      <CardContainer
        alternateHeader
        cardContent1={cardContent1}
        actionsComponent={actionButton}
        subheader={null}/>
    </>
  )
};

export default TeamNameInGamePrompt;
